/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Chat_Tool_Trust_Window_DurationInputs */



/**
* | output |
* | --- |
* | "{minutes} min" |
*
* @param {Chat_Tool_Trust_Window_DurationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_trust_window_duration = /** @type {((inputs: Chat_Tool_Trust_Window_DurationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Trust_Window_DurationInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.minutes} Min.`)
	return /** @type {LocalizedString} */ (`${i?.minutes} min`)
});